/**
 * Бейдж (роль `.t-badge` из §2.2, правила цвета из §2.1).
 *
 * Счётчики и короткие статусы: «Черновик · 14», «Скрыт», «новое», «ошибка».
 * Бейдж тира — отдельный компонент (<TierBadge>): у него своя сетка 22×18 и
 * свой набор токенов.
 *
 * Вариант `draft` — единственное место, где появляется оранжевый, и он идёт
 * подложкой и рамкой, но не текстом: оранжевый текст даёт 2.0:1 (§2.1).
 */
import type { ReactNode } from 'react'
import './Badge.css'

export type BadgeVariant = 'neutral' | 'accent' | 'success' | 'danger' | 'draft' | 'fresh'

export interface BadgeProps {
  children: ReactNode
  variant?: BadgeVariant
  /** Скруглить по-полному: счётчик в доке и в чипе черновика. */
  pill?: boolean
  /** Точка 6 px слева: «есть непросмотренное», «черновик не пуст». */
  dot?: boolean
  /** Подпись для скринридера, если текста бейджа недостаточно. */
  srLabel?: string
  className?: string
}

export function Badge({
  children,
  variant = 'neutral',
  pill = false,
  dot = false,
  srLabel,
  className,
}: BadgeProps) {
  const classes = ['badge', 't-badge', `badge--${variant}`]
  if (pill) classes.push('badge--pill')
  if (className) classes.push(className)

  return (
    <span className={classes.join(' ')}>
      {dot ? <span className="badge__dot" aria-hidden="true" /> : null}
      {srLabel ? <span className="visually-hidden">{srLabel}</span> : null}
      {children}
    </span>
  )
}
